module.exports = __webpack_public_path__ + "static/media/halfcircleglobe.c404e5e3.png";